import {
    BtnHelp,
} from "cartovista";
import { Modal } from 'bootstrap';
import "styles/BtnHelpExtend.css"

export default class BtnHelpExtend extends BtnHelp {
    // constructor(){
    //     super();
    // }
}

var BtnHelpFillListOptions = BtnHelp.prototype._fillListOptions;
BtnHelp.prototype._fillListOptions = function() {
  BtnHelpFillListOptions.call(this);
  this.listHelp.listview.remove(this.listHelp.listview.content.children().last());
  if($('#IntroModal').length){
    this.listHelp.add({
        text: "Aide",
        mode: "HELP",
        icon: "cv-icon-questionMark"
      });
  }
  if($('#CapsulesModal').length){
    this.listHelp.add({
        text: "Capsules d'aide",
        mode: "CAPSULES_VIDEO",
        icon: "bi bi-film"
      });
  }
  if($('#DemoModal').length){
    this.listHelp.add({
        text: "Webinaire (2022)",
        mode: "DEMO_VIDEO",
        icon: "bi bi-camera-reels"
      });
  }
  if(typeof C.APP_TOOLS.AIDE_MEMOIRE != "undefined"){
    this.listHelp.add({
        text: "Aide mémoire",
        mode: "AIDE_MEMOIRE",
        icon: "bi bi-bell"
    });
  }  
  if(typeof C.APP_TOOLS.GUIDE_PDF != "undefined"){
    this.listHelp.add({
        text: "Guide d'utilisateur",
        mode: "GUIDE_PDF",
        icon: "cv-icon-book-small"
    });
  }
};

BtnHelp.prototype.executeAction = function(e) {
  switch (e) {
  case "TOUR":
      this.start();
      break;
  case "HUBSPOT_CHATBOT":
      this._openHubSpotChatBot();
      break;
  case "HELP":
    Modal.getInstance('#IntroModal').show();
      break;
  case "CAPSULES_VIDEO":
    Modal.getInstance('#CapsulesModal').show();
      break;
  case "DEMO_VIDEO":
    Modal.getInstance('#DemoModal').show();
      break;
  case "GUIDE_PDF":
      window.open(C.APP_TOOLS.GUIDE_PDF, '_blank').focus();
      break;
  case "AIDE_MEMOIRE":
    window.open(C.APP_TOOLS.AIDE_MEMOIRE, '_blank').focus();
    break;      
  }
}